'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var navigationItems = context.getElements('.' + context.className + '_Item');
  var navigationOverlay = (0, _functional.getElement)('.js-Navigation_Overlay');

  navigationItems.forEach(function (navigationItem, index) {
    navigationItem.addEventListener('mouseover', function () {
      navigationOverlay.classList.add('hd-Navigation_Overlay-active');
    });
    navigationItem.addEventListener('mouseleave', function () {
      navigationOverlay.classList.remove('hd-Navigation_Overlay-active');
    });
  });
}